import React, {
  useState,
} from 'react';
import { TimeToGetToProps } from './TimeToGetToItem';
import TimeToGetToItem from './TimeToGetToItem';

import { InsightType } from 'utils/entities';
import { StoryWrapper } from './styled';
import { ShowAt } from 'consts/breakpoints';
import Arrow from 'assets/svg/left.svg';
import TimeToGetToStory from './TimeToGetToStory';
import { useTheme } from 'hooks/useTheme';
import { ViewPager } from 'components/view-pager';
import { InsightCarouselShiftedPadding } from 'ds/components/Insights';
import { WithContentSlotSidePaddingContainer } from 'ds/components/Layout';
import { Stories } from 'ds/components/stories';
import { SlideBtn } from 'ds/components/carousels/styled';

interface TimeToGetSectionProps {
  data: TimeToGetToProps[];
}

export const TimeToGetSection: React.FunctionComponent<TimeToGetSectionProps> = (props) => {
  const { data } = props;

  const { isRTL, colors } = useTheme();

  const [ activeCarouselSlide, setActiveCarouselSlide ] = useState(0);
  const handleClickCarousel = (idx:  number) => setActiveCarouselSlide(idx);
  const handleSlideIndexCarouselChange = (idx: number) => setActiveCarouselSlide(idx);

  return (
    <>
      <ShowAt to={2}>
        <WithContentSlotSidePaddingContainer noMobilePadding>
          <StoryWrapper>
            <Stories dotColor={colors.insights[InsightType.Transportation]}>
              {data.map((transportationItem: TimeToGetToProps, index: number) => (
                <TimeToGetToStory
                  key={index}
                  transportationItem={transportationItem}
                />
              ))}
            </Stories>
          </StoryWrapper>
        </WithContentSlotSidePaddingContainer>
      </ShowAt>
      <ShowAt from={3}>
        <InsightCarouselShiftedPadding>
          <ViewPager
            onSlideIndexChange={handleSlideIndexCarouselChange}
            slideIndex={activeCarouselSlide}
            align="left"
            isRTL={isRTL}
          >
            {props.data.map((itemProps: TimeToGetToProps, id: number) =>
              <div key={itemProps ? itemProps.destination : id}>
                <TimeToGetToItem
                  isEmptyTime={itemProps === null}
                  {...itemProps}
                />
              </div>
            )}
          </ViewPager>
        </InsightCarouselShiftedPadding>

        {activeCarouselSlide === 0 ? null : (
          <SlideBtn dir="prev" onClick={() => handleClickCarousel(activeCarouselSlide - 1)}>
            <Arrow/>
          </SlideBtn>
        )}

        {activeCarouselSlide === data.length - 1 ? null : (
          <SlideBtn dir="next" onClick={() => handleClickCarousel(activeCarouselSlide + 1)}>
            <Arrow/>
          </SlideBtn>
        )}
      </ShowAt>
    </>
  );
};
